<template>
  <!-- D: 얼럿은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다. -->
  <!-- CYB_PC_LO_02_00 -->
  <div
    v-if="data.visible"
    class="alert"
    ref="alertRef"
    tabIndex="-1"
    data-alert
  >
    <template v-if="data.type == 'default'">
      <div class="dialog">
        <div class="dialog-content">
          <div class="text-wrap">
            <p v-html="data.message" class="text"></p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area type-full">
            <button
              type="button"
              class="c-button type-primary"
              data-alert-close
              @click="handleClose"
            >
              <span>{{ data.confirmLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="data.type == 'orderComplete'">
      <div class="dialog">
        <div class="dialog-content">
          <div class="text-wrap ac">
            <strong class="subject">주문 완료</strong>
            <p class="text">내용 확인 후 주문 접수 예정입니다.</p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-primary"
              data-alert-close
              @click="handleClose"
            >
              <span>확인</span>
            </button>
          </div>
        </div>
      </div>
      s
    </template>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>

<script setup name="AlertDialog">
import { reactive, onMounted, defineProps, watch, ref, nextTick } from "vue";
import { useAlert } from "@/components/paintpro/composables/useAlert";
const { confirmAction } = useAlert();

const alertRef = ref(null);

const props = defineProps({
  uid: {
    // props로 고유 ID 받기
    type: String,
    required: false,
  },
});

const data = reactive({
  id: "",
  message: "",
  type: "default",
  visible: false,
  options: {},
  confirmLabel: "-",
  cancelLabel: "-",
});

watch(
  () => data.visible,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        handleOpen();
      });
    }
  }
);

onMounted(() => {
  const { visible, message, type, options } = useAlert(props.uId);
  data.id = props.uId;
  data.message = message;
  data.type = type;
  data.options = options;
  data.confirmLabel = options.confirmLabel || "확인";
  data.cancelLabel = options.cancelLabel || "취소";
  data.visible = visible;
  enablePageScroll(); // 초기 상태에서는 스크롤 활성화
});

function handleOpen() {
  alertRef.value.focus();
  setupFocusTrap(alertRef.value);
  disablePageScroll(); // 스크롤 방지
}

function setupFocusTrap(el) {
  // 팝업 내부의 포커스 가능한 요소들
  const focusableElements = el.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length > 0) {
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    el.addEventListener("keydown", function (e) {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  } else {
    el.focus();
  }
}

// 페이지 스크롤 비활성화
const disablePageScroll = () => {
  document.body.style.overflow = "hidden"; // 스크롤 비활성화
};

// 페이지 스크롤 활성화
const enablePageScroll = () => {
  document.body.style.overflow = ""; // 스크롤 원상복구
};

// 팝업을 닫을 때 스크롤을 원래대로 돌려놓기
const handleClose = () => {
  enablePageScroll(); // 팝업 닫을 때 스크롤 복원
  confirmAction();
};
</script>
